import { combineReducers } from 'redux';
import setupIntent from './setupIntent';

export default combineReducers({
  setupIntent,
});
